import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ActivityAction } from '@stores/activity/action';
import type { ThreadAction } from '@stores/thread/action';
import PC from './layout/pc';
import H5 from './layout/h5';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import type { BasePageState } from '../../types/base';

interface RouteParams {
    id: string;
}
interface ActivityDetailProps extends BasePageProps, RouteComponentProps<RouteParams> {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    activity?: ActivityAction;
    thread?: ThreadAction;
}
interface ActivityDetailState extends BasePageState {
    loading: false,
    error: null,
    pageLoaded: false,
    myValue: string;
}
@inject('app', 'site', 'user', 'activity', 'thread')
@observer
class activityDetail extends BasePage<ActivityDetailProps> {
    activityId: any = '';  // 活动id
    namespace = 'activityPostList';
    state: ActivityDetailState = {
        loading: false,
        error: null,
        pageLoaded: false,
        myValue: ''
    };
    componentDidMount() {
        const { app, user, activity, match } = this.props;
        this.activityId = parseInt(match.params.id);
        // if (user) {
        //     user.fetchUserInfo({code: user?.userInfo?.code });
        // }
        this.getActivityDetail();
        this.getActivityPostList();
        super.componentDidMount();
    }
    // 获取活动详情
    getActivityDetail = () => {
        const { activity } = this.props;
        if (activity) {
            activity.getActivityDetail(this.activityId);
        }
    }

    // 获取活动评论列表
    getActivityPostList = () => {
        const { activity } = this.props;
        if (activity) {
            const params = {
                'page[number]': 1,
                'page[size]': 20,
                'filter[type]': 2
            };
            activity.getActivityPostList(params);
        }
    }

    componentDidUpdate(prevProps: any) {
        // 监听路由参数变化，如果活动 ID 改变，重新加载数据
        if (prevProps.match.params.id !== this.props.match.params.id) {
            this.activityId = this.props.match.params.id;
            this.getActivityDetail();
            this.getActivityPostList();
        }
    }

    // 跳转到话题详情页
    handleTopicClick = (id: string | number) => {
        this.props.history && this.props.history.push(`/topicDetail/${id}`);
    };
    

    // 关注用户
    createFollowUser = () => {
        const { activity } = this.props;
        if (activity) {
            let params: any = {
                toUserCode: activity?.activityData?.user?.code
            }
            activity.createFollowUser(params)
        }
    }
    
    // 取消关注用户
    followDelete = () => {
        console.log('取消关注用户');
        const { activity } = this.props;
        if (activity) {
            let params: any = {
                code: activity?.activityData?.user?.code,
                type: 1
            }
            activity.followDelete(params)
        }
    }
    
    // 点赞活动
    likeClick = async (data: any, type: 'activity' | 'post' = 'activity') => {
        const { activity } = this.props;
        const id = activity?.getId ? activity.getId(data) : data?.id;
        if (activity && id) {
            // 通过 action 方法立即更新isLiked状态以获得更好的用户体验
            const isLiked = !data.isLiked;
            if (type === 'activity') {
                activity.updateLikeStatus(isLiked);
            }
            const params = {
                id,
                type,
                isLiked: isLiked,
            };
            // 然后调用 API，API会返回最新的 likeCount
            await activity.createUserslikes(params);
        }
    }

    //收藏（不刷新详情）
    favoriteClick = async (status: boolean) => {
        const { activity } = this.props;
        if (activity) {
            // 通过 action 方法立即更新isFavorite状态以获得更好的用户体验
            const newStatus = !status;
            activity.updateFavoriteStatus(newStatus);
            const params = {
                isFavorite: newStatus,
                id: this.activityId,
                type: 'activity',
            } as any;
            // 然后调用 API，API会返回最新的 favoriteCount
            await activity.activityFavorite(params);
        }
    }
    // 投票
    createActivityVote= (option) => {
        const { activity } = this.props;
        
        if(activity) {
            const activityData = activity?.activityData;
            activity.createVotesOptions(activityData?.votes?.[0].id, option);
            this.getActivityDetail();
        }
        
    }

    // 修改回复/帖子 - id是评论/帖子Id,actionType 是操作类型 ('delete'|'sink'|'sticky')
    postsUpdate = async (id: any, actionType: 'delete' | 'sink' | 'sticky', type: 'post' | 'comment' = 'comment', currentState?: boolean) => {
        const { thread } = this.props;
        if (!thread) return;
        
        const isDeleted = actionType === 'delete' ? true : undefined;
        const isSink = actionType === 'sink' ? !currentState : undefined;
        const isSticky = actionType === 'sticky' ? !currentState : undefined;
        
        const params: any = { id };
        if (typeof isDeleted !== 'undefined') params.isDeleted = isDeleted;
        if (typeof isSink !== 'undefined') params.isSink = isSink;
        if (typeof isSticky !== 'undefined') params.isSticky = isSticky;

        const res = await thread.updateCommentAndSyncList(params);
        const code = typeof res.code !== 'undefined' ? res.code : res.Code;
        if (code !== 0) throw new Error(res.message || res.Message || '操作失败');
        return res;
    }
    
    

    // 只获取数据，不渲染
    getActivityPostListData = () => {
        const { activity } = this.props;
        if (!activity || !activity.listStore) return [];
        const list = activity.listStore.lists[this.namespace];
        if (!list) return [];
        return activity.listStore.getList({ namespace: this.namespace });
    }

    render() {
        const { app } = this.props;
        const platform = app?.platform || 'h5';
        // 如果平台信息还未初始化，显示加载状态
        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        } else {
            return (<div className={platform === 'pc' ? styles.pcWrap : styles.h5Wrap}>
                {platform === 'pc' ? (<PC
                    activityId={this.activityId}
                    createFollowUser={this.createFollowUser}
                    followDelete={this.followDelete}
                    createActivityVote={this.createActivityVote}
                    likeClick={this.likeClick}
                    favoriteClick={this.favoriteClick}
                    postsUpdate={this.postsUpdate}
                ></PC>) : (
                    <H5
                        activityId={this.activityId}
                        createFollowUser={this.createFollowUser}
                        followDelete={this.followDelete}
                        createActivityVote={this.createActivityVote}
                        likeClick={this.likeClick}
                        favoriteClick={this.favoriteClick}
                        postsUpdate={this.postsUpdate}
                    ></H5>
                )}
            </div>)
        }

    }
}

export default withRouter(activityDetail);